module.exports = __webpack_public_path__ + "img/info-adicionais.aed2af5c.png";